import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToAnchor() {
  const location = useLocation();
  const attemptsRef = useRef(0);
  const maxAttempts = 200;

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    attemptsRef.current = 0;
    
    if (hash) {
      const scrollToElement = () => {
        const element = document.getElementById(hash);
        
        if (element) {
          const rect = element.getBoundingClientRect();
          // Перевіряємо чи елемент реально в DOM та має розміри
          if (rect.height > 0 || element.offsetHeight > 0) {
            console.log('Found element, scrolling to:', hash);
            setTimeout(() => {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
            return;
          }
        }
        
        attemptsRef.current++;
        if (attemptsRef.current < maxAttempts) {
          setTimeout(scrollToElement, 500);
        } else {
          console.log('Could not find element:', hash);
        }
      };
      
      // Даємо більше часу на початку для рендеринга
      setTimeout(scrollToElement, 1000);
    }
  }, [location.hash]);

  return null;
}

export default ScrollToAnchor;
